// extracted by mini-css-extract-plugin
export default {"simpleTag":"badge-module--simple-tag--b727e"};